import {
  // getInterventionCategoryData,
  getInterventionItemData,
  getResourceIdsByInterventionId,
  getResourceItemData,
  getRiskFactorsByInterventionId,
} from './utils.js'


export const interventionSummaryTemplate = (category, id) => {
  const itemData = getInterventionItemData(category, id)
  const interventionId = id ? `${category}-${id}` : category

  const hasResources = (getResourceIdsByInterventionId(category, id, itemData)).length > 0
  const hasNotes = Object.hasOwn(itemData, 'notes')
  const hasDevNotes = IS_DEV && Object.hasOwn(itemData, 'dev_notes')

  let detailsHtml = ''
  if (hasResources) {
    detailsHtml += `<li>
      <ph-files size="1.2em" weight="fill" color="var(--icon-color)" aria-hidden="true"></ph-files>
      Resources
    </li>`
  }
  if (hasNotes) {
    detailsHtml += `<li>
      <ph-note-pencil size="1.2em" weight="fill" color="var(--icon-color)" aria-hidden="true"></ph-note-pencil>
      Notes
    </li>`
  }
  if (hasDevNotes) {
    detailsHtml += `<li>
      <ph-chat-text size="1.2em" weight="fill" color="var(--c-yellow-60)" aria-hidden="true"></ph-chat-text>
      Development notes
    </li>`
  }
  if (hasResources || hasNotes || hasDevNotes) {
    detailsHtml = `<ul class="details-inline" role="list">${detailsHtml}</ul>`
  }

  const itemHtml = `
    <button class="btn details-trigger" data-details-for="${interventionId}">
      <span class="intervention-id">${category} P${id}</span>
      <ph-magnifying-glass size="0.9em" weight="bold" color="var(--icon-color)" aria-hidden="true"></ph-magnifying-glass>
    </button>
    <div class="details summary flow">
      <p class="label">${itemData.label}</p>
      ${detailsHtml}
    </div>`
  return `<li class="intervention-info">${itemHtml}</li>`
}


// export const interventionDetailsBtnTemplate = (category, id = undefined, text = 'Details') => {
//   const interventionId = id ? `${category}-${id}` : category
//   const iconSize = getComputedStyle(document.documentElement).getPropertyValue('--icon-size')
//
//   return `<button class="btn details-trigger" data-details-for="${interventionId}">
//       <ph-file-magnifying-glass size="${iconSize}" weight="fill" color="var(--icon-color)" aria-hidden="true"></ph-file-magnifying-glass>
//       ${text}
//     </button>`
// }


export const interventionDetailsTemplate = (category, interventionId, assessmentId, selectedRiskFactors) => {
  const itemData = getInterventionItemData(category, interventionId)

  const headingHtml = `<h4 class="intervention-heading">
      <span class="intervention-id">${category} P${interventionId}</span>
      <span class="intervention-label">${itemData.label}</span>
    </h4>
    <hr>`

  const detailsHtml =
    interventionResourcesTemplate(category, interventionId, itemData)
    + interventionNotesTemplate(itemData)
    + interventionDevNotesTemplate(itemData)

  const riskFactorsHtml = interventionRiskFactorsTemplate(
    category,
    interventionId,
    assessmentId,
    selectedRiskFactors
  )

  return headingHtml + `<div class="details flow">${detailsHtml}${riskFactorsHtml}</div>`
}


export const interventionNotesTemplate = (interventionItemData) => {
  if (!interventionItemData.notes) return ''
  const iconSize = getComputedStyle(document.documentElement).getPropertyValue('--details-icon-size')

  return `<h5 class="details-heading">
      <ph-note-pencil size="${iconSize}" weight="fill" color="var(--icon-color)" aria-hidden="true"></ph-note-pencil>
      Notes
    </h5>
    <div class="details-content">
      ${interventionItemData.notes}
    </div>`
}


export const interventionDevNotesTemplate = (interventionItemData) => {
  if (!IS_DEV || !interventionItemData.dev_notes) return ''

  return `<div class="dev-note">${interventionItemData.dev_notes}</div>`
}


export const interventionResourcesTemplate = (category, interventionId, interventionItemData) => {
  const itemResources = getResourceIdsByInterventionId(category, interventionId, interventionItemData)

  if (itemResources.length > 0) {
    const resourceListHtml = itemResources.map((r) => {
      const data = getResourceItemData(r)
      return `<li><a href="${data.url}">${data.name}</a></li>`
    })
    const iconSize = getComputedStyle(document.documentElement).getPropertyValue('--details-icon-size')

    return `<h5 class="details-heading">
        <ph-folder-simple size="${iconSize}" weight="fill" color="var(--icon-color)" aria-hidden="true"></ph-folder-simple>
        Resources
      </h5>
      <ul class="details-content">
        ${resourceListHtml.join('')}
      </ul>`
  } else {
    return ''
  }
}


export const interventionRiskFactorsTemplate = (interventionCategory, interventionId, assessmentId, selectedRiskFactors) => {
  // Get all associated risk factors:
  const riskFactorData = getRiskFactorsByInterventionId(interventionCategory, interventionId, assessmentId)

  console.log('risk factor data', riskFactorData)

  // Then filter those down to the risk factors that are currently selected in the specified assessment:
  const associatedRiskFactors = riskFactorData.reduce((rfCategories, rfCategory) => {
    const selectedFactors = rfCategory.items.filter((rf) => selectedRiskFactors.includes(rf.id))

    if (!selectedFactors.length > 0) return rfCategories

    return [
      ...rfCategories,
      {
        category_name: rfCategory.category_name,
        id: rfCategory.id,
        items: selectedFactors
      }
    ]
  }, [])

  console.log('associated risk factors', associatedRiskFactors)

  if (associatedRiskFactors.length <= 0) {
    return `<h5 class="details-heading">No associated risk factors currently selected</h5>`
  }

  const riskFactorsHtml = associatedRiskFactors.reduce((html, rfCategory) => {
    if (riskFactorData.length > 1) {
      // There are multiple risk factor categories in this assessment,
      // so include this category's name in a heading.
      html += `<h6 class="details-subheading">${rfCategory.category_name}</h6>`
    }
    return html + `<ul class="details-content">${rfCategory.items.map((item) => '<li>' + item.label + '</li>').join('')}</ul>`
  }, '')

  return `<h5 class="details-heading">Recommended for selected risk factors:</h5>${riskFactorsHtml}`
}
